import React, { useState, useEffect } from 'react';

/*
 * ReadyFilters — نوار فیلتر مشترک فهرست‌های آماده
 * جستجو + هزینه‌ای/تملک + سال مالی؛ هر سه همزمان به سرور فرستاده می‌شوند
 * و تغییر یکی، بقیه را پاک نمی‌کند.
 * سال مالی پیش‌فرض = سال جاری (initialFy)؛ اگر کاربر پاکش کند ⇒ همه.
 *
 * استفاده:
 *   const f = useReadyFilters({ initialFy: year }); // { q, setQ, kind, setKind, fy, setFy, query }
 *   API(`/.../ready/?page=1&${f.query}`)    // query = q&program_type&financial_year
 *   <ReadyFilters f={f} searchLabel="..." />
 */

const toEng = s => String(s || '').replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString());
const toFa  = n => n === null || n === undefined ? '' : String(n).replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);

export function useReadyFilters({ initialFy = '' } = {}) {
  const [q,    setQ]    = useState('');
  const [kind, setKind] = useState('');            // '' همه، '0' هزینه‌ای، '1' تملک
  const [fy,   setFy]   = useState(initialFy ? String(initialFy) : '');
  const [qDeb, setQDeb] = useState('');

  // پیش‌فرض = سال مالی جاری برنامه (عدد ثابت نیست)؛ اگر سال مالی صفحه عوض شد، فیلتر هم عوض شود
  useEffect(() => {
    setFy(initialFy ? String(initialFy) : '');
  }, [initialFy]);

  // جستجو با تأخیر کوتاه تا با هر حرف درخواست نرود
  useEffect(() => {
    const t = setTimeout(() => setQDeb(q.trim()), 400);
    return () => clearTimeout(t);
  }, [q]);

  const parts = [];
  if (qDeb) parts.push(`q=${encodeURIComponent(toEng(qDeb))}`);
  if (kind === '0' || kind === '1') parts.push(`program_type=${kind}`);
  const fyNum = parseInt(toEng(fy), 10) || 0;
  if (fyNum > 0) parts.push(`financial_year=${fyNum}`);

  return { q, setQ, kind, setKind, fy, setFy, fyNum, qDeb, query: parts.join('&') };
}

const st = {
  fld: { display: 'flex', flexDirection: 'column', gap: '4px' },
  lbl: { fontSize: '11px', fontWeight: '600', color: '#555' },
  inp: { padding: '7px 10px', border: '1.5px solid #e0e0e0', borderRadius: '8px', fontSize: '12px',
         fontFamily: "'Vazirmatn',Tahoma,sans-serif", outline: 'none', direction: 'rtl',
         boxSizing: 'border-box', background: '#fff' },
  clr: { padding: '7px 12px', border: '1.5px solid #e0e0e0', borderRadius: '8px', background: '#fff',
         cursor: 'pointer', fontFamily: 'inherit', fontSize: '12px', color: '#555' },
};

export default function ReadyFilters({ f, searchLabel = 'جستجو', kindDisabled = false,
                                       kindTitle = '', children }) {
  const any = f.q || f.kind || f.fy;
  return (
    <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-end', flexWrap: 'wrap' }}>
      <div style={{ ...st.fld, flex: 1, minWidth: '200px' }}>
        <label style={st.lbl}>{searchLabel}</label>
        <input value={f.q} onChange={e => f.setQ(e.target.value)} placeholder="جستجو..."
               style={{ ...st.inp, width: '100%' }} />
      </div>
      <div style={st.fld}>
        <label style={st.lbl}>هزینه‌ای / تملک</label>
        <select value={kindDisabled ? '' : f.kind} disabled={kindDisabled} title={kindTitle}
                onChange={e => f.setKind(e.target.value)}
                style={{ ...st.inp, width: '130px', background: kindDisabled ? '#f5f5f5' : '#fff' }}>
          <option value="">همه</option>
          <option value="0">هزینه‌ای</option>
          <option value="1">تملک</option>
        </select>
      </div>
      <div style={st.fld}>
        <label style={st.lbl}>سال مالی</label>
        <input value={toFa(f.fy)} placeholder="همه"
               onChange={e => f.setFy(toEng(e.target.value).replace(/\D/g, '').slice(0, 4))}
               style={{ ...st.inp, width: '90px', textAlign: 'center' }} />
      </div>
      {any && (
        <button type="button" style={st.clr}
                onClick={() => { f.setQ(''); f.setKind(''); f.setFy(''); }}>✕ پاک کردن فیلترها</button>
      )}
      {children}
    </div>
  );
}
